// extracted by mini-css-extract-plugin
module.exports = {"input":"topics_input__3L8HJ","subjects-filter":"topics_subjects-filter__13tWW","subject-filter":"topics_subject-filter__33sbn"};